export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name, value, { days = 365, path = '/', sameSite = 'Lax', secure = false, domain } = {}) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  let cookie = `${name}=${encodeURIComponent(String(value))}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += '; Secure';
  if (domain) cookie += `; Domain=${domain}`;
  document.cookie = cookie;
}

export function deleteCookie(name, { path = '/', domain } = {}) {
  let cookie = `${name}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path}`;
  if (domain) cookie += `; Domain=${domain}`;
  document.cookie = cookie;
}


// WEBPACK FOOTER //
// ./src/components/utils/cookies.js